import { controlStart, controlEnd } from "@/api/api";
export default {
  directives: {
    clickDown: {
      inserted(el) {
        el.click();
        //  for (let index = 0; index <=3; index++) {
        //   console.log(index)
        //   window.setTimeout(() => {
        //     el.click()
        //   }, 1000);
        //  }
      }
    }
  },

  inject: ["reload"],
  name: "video",
  data() {
    return {
      videoUrl: "",
      img: "",
      intervalId: null,
      id: "",
      bgc: "",
      flag: true,
      playFlag: true,
      fullFlag: false,
      muteFlag: false,
      controlFlag: false,
      controlButtonFlag: false,
      controlChannel: "",
      SD: "", //判断摄像头是否可以控制
      isIos: true,
      miniInfo: {},
      maxInfo: {},
      miniBar: {},
      maxBar: {},
      videoFull: null,
      barFull: null,
      controlMaxFlag: false,
      zoom: 0,
      definitionFlag: false,
      baseUrl: "https://jk-xs.yemast.com:8006",
      definition: "标清",
      name: "",
      rtsp: 1,
      channelList: {},
      load: true,
      direction: "",
      canStop: false,
      nowStop: false
    };
  },
  created() {},
  mounted() {
    // this.channel = this.$route.query.id;
    this.videoUrl = this.$route.query.videoUrl;

    if (this.getPhoneType() == "ios") {
      this.isIos = true;
    } else {
      this.isIos = false;
    }
    this.$nextTick(function() {
      this.miniInfo = {
        width:
          document.documentElement.clientWidth + "px" ||
          document.body.clientWidth + "px",
        height: this.$refs.playBox.offsetHeight + "px",
        position: this.$refs.player.position,
        transform: "translate(0,0) rotate(0deg)"
      };
      this.miniBar = {
        width:
          document.documentElement.clientWidth + "px" ||
          document.body.clientWidth + "px",
        height: this.$refs.bar.offsetHeight + "px",
        position: this.$refs.bar.position,
        transform: "translate(0,0) rotate(0deg)"
      };
      let info = [
          document.documentElement.clientWidth || document.body.clientWidth,
          document.documentElement.clientHeight || document.body.clientHeight
        ],
        w = info[0],
        h = info[1],
        cha = Math.abs(h - w) / 2;
      this.maxInfo = {
        width: h + "px",
        height: w + "px",
        position: "fixed",
        transform: `translate(-${cha}px,${cha}px) rotate(90deg)`
      };
      let barinfo = [
          this.$refs.bar.offsetHeight,
          document.documentElement.clientHeight || document.body.clientHeight
        ],
        barw = barinfo[0],
        barh = barinfo[1],
        barCha = Math.abs(barh - barw) / 2,
        w1 =
          barCha -
          this.$refs.playBox.offsetHeight +
          this.$refs.bar.offsetHeight / 2 -
          3;
      this.maxBar = {
        width:
          document.documentElement.clientHeight + "px" ||
          document.body.clientHeight + "px",
        height: this.$refs.bar.offsetHeight + "px",
        position: this.$refs.bar.position,
        transform: `translate(-${barCha}px,${w1}px) rotate(90deg)`
      };
      if (this.videoUrl) {
        this.load = false;
        // setTimeout(() => {
        this.fullScreen();
        // }, 300);
      }
    });
    // this.isOnline(this.channel);
    // this.getchannels(this.channel);
    // this.dataRefreh(this.channel);
  },
  methods: {
    play() {
      if (this.playFlag) {
        this.$refs.player.pause();
        this.playFlag = false;
      } else {
        this.$refs.player.play();
        this.playFlag = true;
        this.$refs.player.muted = false;
      }
    },
    // 全部方法
    fullScreen() {
      if (!this.fullFlag) {
        this.fullFlag = true;
        this.videoFull = this.maxInfo;
        this.barFull = this.maxBar;
        // if (this.controlButtonFlag) {
        //   this.controlMaxFlag = true;
        //   this.controlButtonFlag = false;
        // }
      }
    },
    // 退出全屏
    goBack() {
      window.history.go(-1);
    },
    // 暂停
    controlButton() {
      if (this.controlFlag) {
        this.controlFlag = false;
        this.controlMaxFlag = false;
        this.controlButtonFlag = false;
      } else {
        this.controlFlag = true;
        if (this.fullFlag) {
          this.controlMaxFlag = true;
        } else {
          this.controlButtonFlag = true;
        }
      }
    },
    //切换清晰度
    definitionButton() {
      this.definitionFlag = true;
    },

    // 镜头调整
    controlDirection(item) {
      if (this.nowStop == false && this.canStop == false) {
        this.direction = item;
        let params = {
          deviceSerial: this.videoData.serialNumber,
          accessToken: this.videoData.accessToken,
          channelNo: this.videoData.channelNo,
          speed: 1,
          direction: this.direction
        };
        controlStart(params).then(res => {
          // console.log(res.data);
          if (res.data == "success") {
            this.canStop = true;
          } else {
            this.canStop = false;
          }
        });
      } else {
        this.$message.error("点击过于频繁,请稍后再试!!!");
        return;
      }
    },

    // 停止
    stopDirection() {
      this.nowStop = true;
    },

    // 停止接口
    getcontrolEnd() {
      let params = {
        deviceSerial: this.videoData.serialNumber,
        accessToken: this.videoData.accessToken,
        channelNo: this.videoData.channelNo,
        speed: 1,
        direction: this.direction
      };
      controlEnd(params).then(res => {
        if (res.data == "success") {
          this.canStop = false;
          this.nowStop = false;
        } else {
          this.getcontrolEnd();
        }
      });
    },

    getPhoneType() {
      let ua = navigator.userAgent.toLowerCase();
      return ua.includes("iphone") ? "ios" : "android";
    }
  },
  watch: {
    canStop(newVal, oldVal) {
      if (newVal == true && this.nowStop == true) {
        this.getcontrolEnd();
      }
    },
    nowStop(newVal, oldVal) {
      if (newVal == true && this.canStop == true) {
        this.getcontrolEnd();
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId); //清除计时器
    this.intervalId = null; //设置为null
  }
};



// WEBPACK FOOTER //
// ./src/view/video/video_index.js